// Arquivo: src/components/Cadastro.js

import React, { useState } from "react";
import { Link } from "react-router-dom";
// import axios from 'axios'; // Usaremos a API segura depois

// NOVO: Recebe a função onLoginSuccess do App.js
const Cadastro = ({ onLoginSuccess }) => {
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    // Validação simples
    if (senha.length < 6) {
      setError("A senha deve ter no mínimo 6 caracteres.");
      setLoading(false);
      return;
    }

    // --- SIMULAÇÃO DA CHAMADA À API (POST /api/auth/register) ---
    console.log(`Tentando cadastrar novo usuário: ${email}`);
    // No futuro, aqui você faria a chamada real para: http://localhost:5000/api/auth/register

    setTimeout(() => {
      const userToken = "jwt.token.user.novo.123456";

      // Define o token e o usuário, e chama a função do pai
      localStorage.setItem("userToken", userToken);
      onLoginSuccess({ id: "user123", email: email, token: userToken });

      setLoading(false);
      // alert('Cadastro bem-sucedido! Redirecionando para a home...'); // Comentado para não poluir
      window.location.href = "/"; // Redireciona para a home
    }, 2000);
    // --- FIM DA SIMULAÇÃO ---
  };

  return (
    <div className="auth-container">
      <h2>Crie sua Conta Grátis</h2>
      <p>É rápido e você ganha acesso aos recursos exclusivos.</p>

      <form onSubmit={handleSubmit}>
        <div className="auth-form-group">
          <label htmlFor="nome">Nome Completo:</label>
          <input
            type="text"
            id="nome"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            required
          />
        </div>
        <div className="auth-form-group">
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="auth-form-group">
          <label htmlFor="senha">Crie uma Senha:</label>
          <input
            type="password"
            id="senha"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            required
          />
        </div>

        {error && <p className="auth-error-message">{error}</p>}

        <button type="submit" disabled={loading}>
          {loading ? "Cadastrando..." : "Cadastrar e Entrar"}
        </button>
      </form>

      <div className="auth-footer-links">
        <p>
          Já tem uma conta? <Link to="/login">Fazer Login</Link>
        </p>
      </div>
    </div>
  );
};

export default Cadastro;
